<template>
  <div v-show="dialogVisible" class="push_card">
    <template v-if="cardInfo.show_mode == 1">
      <PushCardPreview mode="pc-bubble" :lang="lang" ref="preview" @close="close" />
    </template>
    <template v-else>
      <div
        class="preivew-card"
        :class="{ 'preview-card-pad': isTablet }"
        :style="{ zIndex: zIndexServerState.zIndexMap.pushCard }"
      >
        <div class="preview-mask"></div>
        <PushCardPreview mode="pc" :lang="lang" ref="preview" @close="close" />
      </div>
    </template>
    <vh-dialog
      :visible.sync="show"
      :modal="false"
      width="243px"
      class="card-empty"
      @close="close"
      :z-index="3000"
      top="25vh"
    >
      <div class="fail-img">
        <img src="./img/fail.png" alt="" />
      </div>
      <p>{{ $t('card.card_1002') }}</p>
    </vh-dialog>
  </div>
</template>
<script>
  import { PushCardPreview, commonApi } from '@vhcl/push-card';
  import { useRoomBaseServer, useMsgServer, useZIndexServer } from 'middle-domain';
  export default {
    name: 'VmpCardPreview',
    components: {
      PushCardPreview
    },
    provide() {
      return {
        getWatchInitData: () => this.roomBaseServer.state.watchInitData,
        env: this.env
      };
    },
    data() {
      const { watchInitData = {}, languages } = this.roomBaseServer.state;
      const { webinar = {} } = watchInitData;
      const zIndexServerState = this.zIndexServer.state;
      return {
        zIndexServerState,
        dialogVisible: false,
        env: process.env.VUE_APP_ENV,
        webinarId: webinar.id,
        cardInfo: {},
        show: false,
        lang: languages.lang.type,
        isTablet: window.isTablet
      };
    },

    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.zIndexServer = useZIndexServer();
      const { PushCard } = commonApi;
      this.cardServer = new PushCard();
    },
    created() {
      useMsgServer().$onMsg('ROOM_MSG', msg => {
        if (msg.data.type == 'live_over') {
          // 结束直播
          this.close();
        }
      });
    },
    methods: {
      close(cardInfo) {
        this.dialogVisible = false;
      },
      async open(cardInfo) {
        try {
          const cardId = cardInfo.id;
          const res = await this.cardServer.getPushCard({
            webinar_id: this.webinarId,
            id: cardInfo.id || cardInfo.card_id
          });
          if (res?.code === 200) {
            this.cardInfo = res.data;
            this.dialogVisible = true;
            this.show = false;
            this.$nextTick(() => {
              this.$refs.preview.open(this.cardInfo);
            });

            const { switch: switchInfo } = this.roomBaseServer.state.watchInitData;
            let cardIds = sessionStorage.getItem(switchInfo.switch_id);
            if (!cardIds) {
              cardIds = cardId;
            } else {
              if (!cardIds.includes(cardId)) {
                cardIds = `${cardIds},${cardId}`;
              }
            }
            // 查看卡片时将查看的id缓存
            sessionStorage.setItem(switchInfo.switch_id, cardIds);
            this.zIndexServer.setDialogZIndex('pushCard');
          } else if (res.code === 513600) {
            this.zIndexServer.setDialogZIndex('pushCard');
            this.$refs.preview.handleClose();
            this.dialogVisible = true;
            this.show = true;
          } else {
            this.show = false;
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.show = false;
          console.log(error);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .push_card {
    /deep/ .pc-bubble {
      position: absolute;
      z-index: 10;
      bottom: 90px;
      right: 16px;
      height: auto;
    }
  }
  .preivew-card {
    position: fixed;
    top: 0;

    .preview-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }
    &.preview-card-pad {
      /deep/.push-card-preview .card-img {
        top: 5vh;
      }
    }
  }
  .card-empty {
    .fail-img {
      margin: 10px auto 0;
      width: 90px;
    }
    img {
      width: 100%;
    }
    p {
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #262626;
      margin-bottom: 40px;
      margin-top: -13px;
      word-break: break-word;
    }
  }
</style>
